"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorScale = void 0;
var tslib_1 = require("tslib");
var lodash_1 = require("lodash");
var d3 = tslib_1.__importStar(require("../d3-modules"));
var color_1 = require("./color");
var domain_1 = require("./domain");
/** List of names of available continuous color schemes */
var D3ContinuousSchemes = Object.keys(d3).filter(function (k) {
  return k.indexOf('interpolate') === 0;
}).map(function (k) {
  return k.replace(/^interpolate/, '');
});
/** List of names of available categorical color schemes */
var D3CategoricalSchemes = Object.keys(d3).filter(function (k) {
  return k.indexOf('scheme') === 0 && isStringArray(d3[k]);
}).map(function (k) {
  return k.replace(/^scheme/, '');
});
/** List of names of all available color schemes */
var D3Schemes = (0, lodash_1.uniq)(tslib_1.__spreadArray(tslib_1.__spreadArray([], D3ContinuousSchemes, true), D3CategoricalSchemes, true)).sort();
function continuousScaleFromColors(values, colors) {
  if (values.length !== colors.length) throw new Error('`values` and `colors` must have the same length');
  var n = values.length;
  var theDomain = domain_1.Domain.create(values);
  var theColors = colors.map(function (c) {
    return typeof c === 'string' ? color_1.Color.fromString(c) : c;
  });
  if (!theDomain.isNumeric || theDomain.sortDirection === 'none') {
    throw new Error('Provided list of `values` is not numeric and monotonous');
  }
  function colorScale(x) {
    var contIndex = (0, lodash_1.clamp)(domain_1.Domain.interpolateIndex(theDomain, x), 0, n - 1);
    var index = Math.floor(contIndex);
    if (index === n) return theColors[n];else return color_1.Color.mix(theColors[index], theColors[index + 1], contIndex - index);
  }
  ;
  return colorScale;
}
function continuousScaleFromScheme(schemeName, domain, range_) {
  if (domain === void 0) {
    domain = [0, 1];
  }
  if (range_ === void 0) {
    range_ = [0, 1];
  }
  var colorInterpolator = d3["interpolate".concat(schemeName)];
  if (colorInterpolator !== undefined) {
    var n = 101;
    var values = linspace(domain, n);
    var colors = colorsFromInterpolator(colorInterpolator, range_, n);
    return continuousScaleFromColors(values, colors);
  }
  throw new Error("Invalid color scheme name: \"".concat(schemeName, "\".\n(Available schemes: ").concat(exports.ColorScale.ContinuousSchemes, ")"));
}
function continuous(a, b, c) {
  if (typeof a === 'string') return continuousScaleFromScheme(a, b, c);else return continuousScaleFromColors(a, b);
}
function discreteScaleFromColors(values, colors, unknownColor) {
  if (unknownColor === void 0) {
    unknownColor = '#888888';
  }
  if (values.length !== colors.length) throw new Error('`values` and `colors` must have the same length');
  var n = values.length;
  var map = new Map();
  for (var i = 0; i < n; i++) {
    var color = colors[i];
    map.set(values[i], typeof color === 'string' ? color_1.Color.fromString(color) : color);
  }
  var fallbackColor = typeof unknownColor === 'string' ? color_1.Color.fromString(unknownColor) : unknownColor;
  function discreteColorScale(x) {
    var _a;
    return (_a = map.get(x)) !== null && _a !== void 0 ? _a : fallbackColor;
  }
  ;
  return discreteColorScale;
}
function discreteScaleFromScheme(schemeName, values, unknownColor) {
  var scheme = d3["scheme".concat(schemeName)];
  if (isStringArray(scheme)) {
    var colorList = scheme.map(function (s) {
      return color_1.Color.fromString(s);
    });
    return discreteScaleFromColors(values, cycle(colorList, values.length), unknownColor);
  }
  var colorInterpolator = d3["interpolate".concat(schemeName)];
  if (colorInterpolator !== undefined) {
    var n = values.length;
    var colors = colorsFromInterpolator(colorInterpolator, [0, 1], n);
    return discreteScaleFromColors(values, colors, unknownColor);
  }
  throw new Error("Invalid color scheme name: \"".concat(schemeName, "\".\n(Available schemes: ").concat(exports.ColorScale.DiscreteSchemes, ")"));
}
function discrete(a, b, c) {
  if (typeof a === 'string') return discreteScaleFromScheme(a, b, c);else return discreteScaleFromColors(a, b, c);
}
function linspace(range_, n) {
  var scale = d3.scaleLinear([0, n - 1], range_);
  return (0, lodash_1.range)(n).map(function (i) {
    return scale(i);
  });
}
function colorsFromInterpolator(colorInterpolator, range_, nColors) {
  return linspace(range_, nColors).map(function (x) {
    return color_1.Color.fromString(colorInterpolator(x));
  });
}
function isStringArray(value) {
  return (0, lodash_1.isArray)(value) && value.length > 0 && typeof value[0] === 'string';
}
function cycle(source, n) {
  var result = [];
  while (result.length < n) {
    result.push.apply(result, source);
  }
  result.length = n;
  return result;
}
/** Functions for creating color scales to be used with heatmap. */
exports.ColorScale = {
  /** List of available color schemes for `ColorScale.continuous()` */
  ContinuousSchemes: D3ContinuousSchemes,
  // continuous can only be used with continuous D3 schemes
  /** List of available color schemes for `ColorScale.discrete()` */
  DiscreteSchemes: D3Schemes,
  // discrete can be used with both categorical and continuous D3 schemes
  /** Create a continuous color scale, i.e. a mapping from real number to color.
   * Examples:
   * ```
   * continuous('Magma', [0, 1], [0, 1])
   * continuous([0, 0.5, 1], ['white', 'orange', 'brown'])
   * ``` */
  continuous: continuous,
  /** Create a discrete (categorical) color scale, i.e. a mapping from values of any type to colors.
   * Examples:
   * ```
   * discrete('Set1', ['dog', 'cat', 'fish'], 'gray')
   * discrete(['dog', 'cat', 'fish'], ['red', 'green', 'blue'], 'gray')
   * ``` */
  discrete: discrete
};